"use strict";require("hesehus-js-parallax"),$("[data-parallaxbehaviour]").hParallax({$scrollTarget:$(".wrapper__view--main")});